module.exports = __webpack_public_path__ + "img/logo-codelex.1874aaf2.svg";